var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "account_box" },
    [
      _c("div", { staticClass: "title" }, [_vm._v("礼金补贴推广位管理")]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "mt20",
          staticStyle: {
            background: "#fff",
            padding: "30px",
            "border-radius": "20px",
          },
        },
        [
          _c("div", { staticClass: "search_criteria" }, [
            _c(
              "div",
              { staticStyle: { "margin-left": "0" } },
              [
                _c("el-input", {
                  attrs: { placeholder: "输入推广位pid查询", clearable: "" },
                  model: {
                    value: _vm.queryData.pid,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryData, "pid", $$v)
                    },
                    expression: "queryData.pid",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c(
                  "el-select",
                  {
                    attrs: { placeholder: "选择推广位占用状态", clearable: "" },
                    model: {
                      value: _vm.queryData.status,
                      callback: function ($$v) {
                        _vm.$set(_vm.queryData, "status", $$v)
                      },
                      expression: "queryData.status",
                    },
                  },
                  [
                    _c("el-option", { attrs: { value: 0, label: "未占用" } }),
                    _vm._v(" "),
                    _c("el-option", { attrs: { value: 1, label: "占用" } }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("el-input", {
                  attrs: { placeholder: "输入会员ID搜索", clearable: "" },
                  model: {
                    value: _vm.queryData.memberId,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryData, "memberId", $$v)
                    },
                    expression: "queryData.memberId",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              [
                _c("el-input", {
                  attrs: { placeholder: "输入会员手机号搜索", clearable: "" },
                  model: {
                    value: _vm.queryData.phone,
                    callback: function ($$v) {
                      _vm.$set(_vm.queryData, "phone", $$v)
                    },
                    expression: "queryData.phone",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "flex",
                staticStyle: { width: "fit-content", height: "40px" },
              },
              [
                _c(
                  "el-button",
                  {
                    staticStyle: { height: "40px" },
                    attrs: { type: "primary" },
                    on: { click: _vm.onInquire },
                  },
                  [_vm._v("查询")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "ml10",
                    staticStyle: { height: "40px" },
                    attrs: { type: "info", plain: "" },
                    on: { click: _vm.onInitialize },
                  },
                  [_vm._v("重置")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", plain: "" },
                    on: { click: _vm.onRecharge },
                  },
                  [_vm._v("添加推广位")]
                ),
                _vm._v(" "),
                _c("el-button", { attrs: { type: "danger", plain: "" } }, [
                  _vm._v(
                    "推广位占用数量" + _vm._s(_vm.getTljPidUseInfoData.useNum)
                  ),
                ]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt20" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    border: "",
                    data: _vm.tableData,
                    "tooltip-effect": "dark",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: { label: "推广位pid", prop: "pid", align: "center" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "changeMethod",
                      label: "占用状态",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("div", [
                              scope.row.status === 1
                                ? _c("div", [_vm._v("占用")])
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.status === 0
                                ? _c("div", [_vm._v("未占用")])
                                : _vm._e(),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "phone",
                      label: "推广位占用用户",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              {
                                staticClass: "pointer",
                                staticStyle: {
                                  "font-size": "14px",
                                  color: "#4d8aff",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.onUserDetails(scope.row)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.nickName) +
                                    "\n            "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", [
                              _vm._v(
                                "uid:" + _vm._s(scope.row.memberId || "-")
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { prop: "phone", label: "手机号", align: "center" },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "添加时间",
                      align: "center",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "操作", align: "center" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.status === 0
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: { size: "mini" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDel(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("删除")]
                                )
                              : _c("div", [_vm._v("-")]),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mt20 page_box" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.queryData.page,
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.queryData.size,
                  layout: "total, prev, pager, next, sizes,jumper",
                  total: _vm.total,
                  background: "",
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-dialog",
            {
              attrs: {
                visible: _vm.dialogVisible,
                "close-on-click-modal": false,
                title: _vm.titleTxt,
                width: "900px",
                top: "10vh",
                "custom-class": "dialog_box",
              },
              on: { close: _vm.onClose },
            },
            [
              _c(
                "div",
                [
                  _c(
                    "el-form",
                    {
                      ref: "ruleForm",
                      staticClass: "demo-ruleForm",
                      attrs: {
                        model: _vm.ruleForm,
                        rules: _vm.rules,
                        "label-width": "100px",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "推广位pid", prop: "pid" } },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "请输入推广位pid" },
                            model: {
                              value: _vm.ruleForm.pid,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm, "pid", _vm._n($$v))
                              },
                              expression: "ruleForm.pid",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              on: {
                                click: function ($event) {
                                  return _vm.submitForm("ruleForm")
                                },
                              },
                            },
                            [_vm._v("提交")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          padding: "10px 10px 10px 20px",
          "line-height": "26px",
          color: "#f56c6c",
          background: "#D9EDF7",
        },
      },
      [
        _c("div", [
          _vm._v(
            "1.App上线礼金补贴活动功能模块前务必先添加好推广位，否则会导致用户无法领取礼金红包!"
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "2.当用户创建商品的淘礼金时会占用一个推广位(与商品数量无关)，推广位占用完后会导致其他用户无法创建淘礼金，所以要及时增加推广位；当用户创建的淘礼金都失效后会释放推广位;"
          ),
        ]),
        _vm._v(" "),
        _c("div", [
          _vm._v(
            "3.总共可添加100个推广位，一旦当前值超过默认值，不支持再新增！"
          ),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }